//# sourceMappingURL=window.mjs.map
/// <reference types="./window.d.mts" />
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $route from "../../data/route.mjs";
import { updateTitle as update_title } from "./window.ffi.ts";

/**
 * Update document page `<title>` according to the route.
 * Used to help user to find the location easily.
 */
export function update_page_title(route) {
  return $effect.from(
    (_, _1) => {
      let _pipe = $route.to_title(route);
      let _pipe$1 = ((_capture) => {
        return $string.append("Steerlab — ", _capture);
      })(_pipe);
      return update_title(_pipe$1);
    },
  );
}
